// @flow

/**
 * Module dependencies.
 */

import { Col, Container, Row } from 'client/components/core/grid';
import { LinkDefault } from 'client/components/core/buttons/links';
import { List, ListItem } from 'client/components/core/lists';
import { breakpoints, colors, fixedHeight, media, units } from 'client/styles';
import { getLocalizedUrl } from 'client/core/utils';
import { map } from 'lodash/fp';
import { position, size } from 'polished';
import Layout from 'client/components/core/layout';
import MediaQuery from 'react-responsive';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  author: string,
  copyright: string,
  links: Array<Object>,
  techPartner: string
};

/**
 * `Section` component.
 */

const Section = styled.section`
  ${position('absolute', null, '0', '0', '0')}
  ${size(fixedHeight.footer, '100%')}

  display: table;
`;

/**
 * `StyledContainer` component.
 */

const StyledContainer = styled(Container)`
  margin-top: ${units(5)};
  vertical-align: middle;
`;

/**
 * `StyledTextSmall` styled component.
 */

// $FlowFixMe
const StyledTextSmall = styled(Text.Small)`
  color: ${colors.shadesOfBlue.paleSky};
  display: block;
  line-height: ${units(3)};
  margin-bottom: 0;

  &:first-child {
    margin-top: ${units(0.5)};
  }

  ${media.min.lg`
    display: inline-block;
    margin-right:${units(2)};
  `}
`;

/**
 * `StyledListItem` component.
 */

const StyledListItem = styled(ListItem)`
  padding: 0 ${units(2)};
`;

/**
 * Render links.
 */

const renderLinks = map((link: Object): React$Element<*> => (
  <StyledListItem key={link.title}>
    <LinkDefault
      color={colors.shadesOfBlue.oxfordBlue}
      to={getLocalizedUrl(link.key)}
    >
      {link.title}
    </LinkDefault>
  </StyledListItem>
));

/**
 * `Footer` component.
 */

function Footer(props: Props): React$Element<*> {
  const { author, copyright, links, techPartner } = props;

  return (
    <Section>
      <StyledContainer>
        <Row>
          <Col
            lg={3}
            lgOffset={1}
            xs={10}
            xsOffset={1}
          >
            <Layout
              textAlign={'center'}
              textAlignLg={'left'}
            >
              <Text.Paragraph>
                {copyright}
              </Text.Paragraph>

              <div>
                <StyledTextSmall>
                  <RawHtml.span>
                    {author}
                  </RawHtml.span>
                </StyledTextSmall>

                <StyledTextSmall>
                  <RawHtml.span>
                    {techPartner}
                  </RawHtml.span>
                </StyledTextSmall>
              </div>
            </Layout>
          </Col>

          <MediaQuery minWidth={breakpoints.md}>
            <Col
              lg={7}
              lgOffset={0}
            >
              <Layout
                textAlign={'center'}
                textAlignLg={'right'}
              >
                <List>
                  {renderLinks(links)}
                </List>
              </Layout>
            </Col>
          </MediaQuery>
        </Row>
      </StyledContainer>
    </Section>
  );
}

/**
 * Export `Footer`.
 */

export default Footer;



// WEBPACK FOOTER //
// ../src/client/components/footer/index.js